import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'

/**
 * SharedNotesCard — session-notes (catalog #6, CORE).
 *
 * Single co-edited multi-line textarea — catch-all for in-session notes.
 * Single band (no private vs shared split — that's the prep canvas variant).
 *
 * Phase F: singleton note row (slot="shared-notes").
 * Co-edit: both parties see updates; Phase F follow-up wires the
 * onSessionRowChanged subscription for live updates.
 * // Phase F follow-up: subscribe to onSessionRowChanged for live co-edit.
 */

export function SharedNotesCard({ text = '', onChange, disabled = false }) {
  return (
    <CardFrame
      kind="session"
      icon="≡"
      iconClass="olive"
      title="Shared notes"
      prompt="Anything to capture here?"
      state={disabled ? 'locked' : text ? 'filled' : 'empty'}
      data-testid="session-card-shared-notes"
      className="session-card"
    >
      <textarea
        className="session-card__textarea session-card__textarea--notes"
        value={text}
        disabled={disabled}
        placeholder={disabled ? '' : 'Notes visible to both of you…'}
        onChange={(e) => onChange?.(e.target.value)}
        aria-label="Shared notes"
        rows={6}
      />
    </CardFrame>
  )
}
